import { IEventrActivity, ITodoList } from "@eventr/common";
import { useMemo } from "react";
import { useBoundStore } from "state/bound.store";
import { selectAllPublishedTodos, selectPendingTodoCount } from "state/itineraryState/currentItin.slice";
import { useShallow } from "zustand/react/shallow";

export const usePendingTodoCount = (todoList: ITodoList) => {
  const pendingCount = useMemo(() => {
    return selectPendingTodoCount(useBoundStore.getState(), todoList);
  }, [todoList]);

  return pendingCount;
};

export const useTotalPendingTodoCount = (filterOutPartialDateTodos?: boolean) => {
  const { todos } = useBoundStore(useShallow((s) => ({ todos: s.itineraryComponents.todos })));

  const pendingCount = useMemo(() => {
    const todosToCount = filterOutPartialDateTodos ? todos.filter((todo) => todo.start_by && todo.due_date) : todos;

    if (todosToCount.length === 0) return 0;

    return todosToCount.reduce((total, todo) => {
      // Calculate pending count for each todo list
      const pendingCount = selectPendingTodoCount(useBoundStore.getState(), todo);
      return total + pendingCount;
    }, 0);
  }, [filterOutPartialDateTodos, todos]);

  return pendingCount;
};

export const useTotalAllPendingTodoCount = (todos?: IEventrActivity[]) => {
  const allTodos = useBoundStore(selectAllPublishedTodos);
  const todosToUse = todos ?? allTodos;

  const pendingCount = useMemo(() => {
    return todosToUse.reduce((total: any, todo: any) => {
      // Calculate pending count for each todo list
      const pendingCount = selectPendingTodoCount(useBoundStore.getState(), todo);
      return total + pendingCount;
    }, 0);
  }, [todosToUse]);

  return pendingCount as number;
};
